
        <div *ngIf="enabled" class="total-padding" [style.height]="scrollHeight + 'px'"></div>
        <div #content
             [class.scrollable-content]="enabled"
             [style.transform]="enabled ? 'translateY(' + topPadding + 'px)' : 'none'"
             [style.webkitTransform]="enabled ? 'translateY(' + topPadding + 'px)' : 'none'">
            <ng-content></ng-content>
        </div>
    